import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth-store', () => {
  const accessToken = ref<string>('')
  const isAuthenticated = ref(!!accessToken.value)

  const getAccessToken = () => accessToken.value

  const setAccessToken = (newAccessToken: string) => {
    accessToken.value = newAccessToken
    isAuthenticated.value = true
  }

  const clearTokens = () => {
    accessToken.value = ''
    isAuthenticated.value = false
  }

  return {
    isAuthenticated,
    getAccessToken,
    setAccessToken,
    clearTokens,
  }
})
